import { render, staticRenderFns } from "./packaging-data-card.vue?vue&type=template&id=706b5e80&scoped=true"
import script from "./packaging-data-card.vue?vue&type=script&lang=js"
export * from "./packaging-data-card.vue?vue&type=script&lang=js"
import style0 from "./packaging-data-card.vue?vue&type=style&index=0&id=706b5e80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b5e80",
  null
  
)

export default component.exports